module.exports = __webpack_public_path__ + "img/open2.2a813170.png";